import { render, staticRenderFns } from "./ViHome.vue?vue&type=template&id=01c6477d&scoped=true"
import script from "./ViHome.vue?vue&type=script&lang=js"
export * from "./ViHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6477d",
  null
  
)

export default component.exports